var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_414",
    "data-name": "Groupe 414",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M8.909,7.636a.637.637,0,0,1,0-1.273h1.273a2.547,2.547,0,0,0,2.534-2.778,2.637,2.637,0,0,0-2.669-2.313H8.909A.636.636,0,0,1,8.273.636c0-.352.282-.636.795-.636h.961A3.922,3.922,0,0,1,13.97,3.336a3.822,3.822,0,0,1-3.788,4.3Zm-5.091,0A3.823,3.823,0,0,1,.032,3.316,3.908,3.908,0,0,1,3.951,0h1.14a.637.637,0,0,1,0,1.273H3.818A2.547,2.547,0,0,0,1.284,4.051,2.636,2.636,0,0,0,3.952,6.363H5.091a.636.636,0,0,1,0,1.273ZM5.091,4.454a.636.636,0,0,1,0-1.273H8.909a.637.637,0,1,1,0,1.273Z",
    transform: "translate(1 4)",
    fill: "#c5a47e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.db7d3f06d116c1be71b9fc1c65b24c16.svg";
export { ForwardRef as ReactComponent };